export const suggestMock = {
    "people": {
        "result": [
            {
                "url": "https://staff.yandex-team.ru/test",
                "title": "Тест Тестов",
                "login": "test"
            }
        ]
    }
   ,"groups": {
        "result": [
            {
                "url": "https://staff.yandex-team.ru/groups/yandex_test",
                "title": "Группа тестовая",
                "department": "yandex_test"
            }
        ]
    }
};
